class SessionHelper {

    constructor() { }
    getUser() {
        return eval("(" + localStorage.getItem("User") + ")");
    }
    setUser(user) {
        localStorage.setItem("User", JSON.stringify(user));
    }
    isUserValid(){
        if(this.getUser() != null){
            return true;
        }
        return false;
    }
    logout(){
        localStorage.removeItem('User');
    }
}
const sessionHelper = new SessionHelper();
export default sessionHelper;
